<template>
  <div class="nebModal">
    <transition name="modal">
      <div v-if="isOpen">
        <div class="nebModal-overlay"
          @click.self="$emit('clickOutside')"
        >
          <div class="nebModal-modal">
            <div class="nebModal-modal-header">
              <slot name="header">
                <div class="title">
                  <h3>{{ title }}</h3>
                </div>
              </slot>
            </div>

            <div class="nebModal-modal-content">
              <slot></slot>
            </div>

            <div class="nebModal-modal-footer">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'NebModal',

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style  lang="scss">
@import  '../../style.scss';

.nebModal {
  &-modal {
    margin: 0 auto;
    background-color: $white;
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    overflow: hidden;
    border-top: 5px solid $tiffany-blue;

    &-header {
      padding: 20px;
      border-bottom: 1px solid $pinkish-grey;
      box-sizing: border-box;

      .title {
        h3 {
          font-family: $defaultFont;
          font-size:  22px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: $slate-grey;
        }
      }
    }

    &-content {
      padding: 20px;
      overflow: hidden;
      box-sizing: border-box;
    }

    &-footer {
      padding: 20px;
      border-top: 1px solid $pinkish-grey;
      box-sizing: border-box;
    }
  }

  &-overlay  {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: #00000094;
    z-index: 999;
    transition: opacity 0.2s ease;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .fadeIn-enter {
    opacity: 0;
  }

  .fadeIn-leave-active {
    opacity: 0;
    transition: all 0.2s step-end;
  }

  .fadeIn-enter.modal,
  .fadeIn-leave-active.modal {
    transform: scale(1.1);
  }
}
</style>
